import React from 'react';

const ErrorText = ({ text, text2='is required' }) => {
    return (
        <label className="small text-start text-danger text-center mt-1">{`${text} ${text2}`}</label>
    );
};

export default ErrorText;